export default "__VITE_ASSET__BqboopZp__"